import { create } from "zustand";

interface TrackingContextState {
  source: string | null;
  pointsConsumed: number | null;
  setSource: (source: string | null) => void;
  setPointsConsumed: (points: number | null) => void;
  clear: () => void;
}

/**
 * Reproイベントに付与するコンテキスト（遷移起点・消費ポイント）を保持するストア。
 * trackEvent 呼び出し時にイベント設定（eventTrackingConfig）に応じて参照・クリアされる。
 */
export const useTrackingContextStore = create<TrackingContextState>()(
  (set) => ({
    source: null,
    pointsConsumed: null,
    setSource: (source) => set({ source }),
    setPointsConsumed: (points) => set({ pointsConsumed: points }),
    clear: () => set({ source: null, pointsConsumed: null }),
  }),
);
